export const frontLink = '/front';
export const remoteDiagnosisLink = frontLink + '/remote-diagnosis';
export const diagnosisHistoryLink = frontLink + '/diagnosis-history';
export const errorLink = '/error';
